import { observer } from "mobx-react-lite";
import { Form, Input, Modal, Button, Select } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import AppStore from "../../../../stores/User/AppStore";

export interface OtherTagDialogProps {
  visible: boolean;
  close: () => void;
}

const OtherTagDialog: React.FC<OtherTagDialogProps> = (props) => {
  const [form] = Form.useForm();
  useEffect(() => {
    form.resetFields();
  }, [props.visible]);

  const submit = () => {
    form
      .validateFields()
      .then((res) => {
        console.log(res);
        const { tag } = form.getFieldsValue();
        AppStore.addTag("2", tag);
        props.close();
      })
      .catch((err) => {});
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 20, offset: 4 },
    },
  };
  return (
    <Modal
      forceRender
      title="添加其他标签"
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      okText="确认"
      cancelText="取消"
    >
      <Form
        form={form}
        name="dynamic_form_item"
        {...formItemLayoutWithOutLabel}
      >
        <Form.List
          name="tag"
          rules={[
            {
              validator: async (_, names) => {
                if (!names) {
                  return Promise.reject(new Error("输入标签名称"));
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }, { errors }) => (
            <>
              {fields.map((field, index) => (
                <Form.Item
                  {...(index === 0
                    ? formItemLayout
                    : formItemLayoutWithOutLabel)}
                  label={index === 0 ? "标签名" : ""}
                  required={false}
                  key={field.key}
                >
                  <Form.Item
                    {...field}
                    validateTrigger={["onChange", "onBlur"]}
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: "输入标签名",
                      },
                    ]}
                    noStyle
                  >
                    <Input
                      placeholder="请输入标签名"
                      style={{ width: "60%" }}
                    />
                  </Form.Item>
                  {fields.length > 1 ? (
                    <MinusCircleOutlined
                      className="dynamic-delete-button"
                      onClick={() => remove(field.name)}
                    />
                  ) : null}
                </Form.Item>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  style={{ width: "60%" }}
                  icon={<PlusOutlined />}
                >
                  添加标签
                </Button>
                <Form.ErrorList errors={errors} />
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};
export default observer(OtherTagDialog);
